export enum PlatformTypes {
    full = 'full',
    lite = 'lite',
}
